import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import {
  CustomerSentiment,
  Insights,
  Interaction_Summary_List,
  InteractionSummary,
  InteractionTime,
} from '../report.constants';
import { InteractionPage, UIDataModel } from '../report.model';
import { CustomDateTimePipe } from '../../../pipes/custom-date-time.pipe';
import { FormatTimestampPipe } from '../../../pages/dashboard/tabular-view/pipes/format-timestamp-pipe.pipe';
import { SentimentIconPipe } from '../../../pipes/sentiment-icon.pipe';

@Component({
  selector: 'interaction-report',
  standalone: true,
  imports: [CommonModule, CustomDateTimePipe, FormatTimestampPipe, SentimentIconPipe],
  providers: [DatePipe],
  templateUrl: './interaction-report.component.html',
  styleUrl: './interaction-report.component.scss',
})
export class InteractionReportComponent {
  @Input() interactionData: InteractionPage | { [key: string]: string | number | undefined } = {};
  @Input() index: number = 1;

  tableRows: Array<UIDataModel> = Insights;
  details: Array<UIDataModel> = Interaction_Summary_List;
  interactionSummary = InteractionSummary;
  interactionTime = InteractionTime;
  customerSentiment = CustomerSentiment;

  ngOnInit(): void {}
}
